import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('h_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('h_token');
    }
    return Promise.reject(error);
  }
);

export const HERITAGE_ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/re4biuvb_APPARELHERO_001.png',
  dahliaMark: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/re4biuvb_APPARELHERO_001.png',
  heroBanner: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/i86kvpgb_HERITAGE-APPAREL-BANNER.png',
  heroSubBanner: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/2y789y75_file_000000009a7871fbaf93ced68ffb08d1.png',
  heroText: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/rsxw3evb_HERITAGE-APPAREL-HERO-TEXT.png',
  swatches: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/g35b7sb8_file_00000000a7507207ae076189b08b4984.png',
  sizeGuideSheet: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/8tsfhxhp_file_0000000091a871f887572e360e387930.png',
  tracksuitField: 'https://customer-assets.emergentagent.com/job_9514e509-8bea-43b9-b1d4-1d2affd477e8/artifacts/qqq3ktr2_file_00000000affc71fbbb308793d46914cb.png',
  editorial: 'https://customer-assets.emergentagent.com/job_9514e509-8bea-43b9-b1d4-1d2affd477e8/artifacts/r2qd2r80_file_00000000e6847207b5022c40b882d6b1.png',
  socks: 'https://customer-assets.emergentagent.com/job_9514e509-8bea-43b9-b1d4-1d2affd477e8/artifacts/9n2f8mw3_file_00000000a8a071fb9875bd3b5499daac.png',
  catalogHalfZip: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/y079fimj_file_000000009d6071fabbb91e7c806040f7.png',
  catalogHoodie: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/61bv3y4z_file_000000008db471faa902f4536dfc7536.png',
  catalogContourPants: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/enpxv0r0_file_000000006e5472078c11daaf7a1419b5.png',
  catalogUnisexPants: 'https://customer-assets.emergentagent.com/job_vintage-style-2/artifacts/rqmkoz4o_file_000000004d8871fa978a40b9ec00435c.png',
};
